export default __webpack_public_path__ + "static/Make-up-set-for-easy-travel-ac20eec5842772f326a8151e52917fad.jpg";